var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNwnBroom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 228 334",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Gra-Blu",
    serifId: "Gra/Blu",
    transform: "matrix(2.60137,0,0,2.60137,-2989.89,-311.451)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.418878,0,0,0.418878,540.447,4.55175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mop1",
    serifId: "Mop"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1594.93,431.777C1594.93,428.001 1591.86,424.936 1588.09,424.936L1526.78,424.936C1523,424.936 1519.93,428.001 1519.93,431.777L1519.93,453.03C1519.91,453.053 1594.93,452.874 1594.93,452.842L1594.93,431.777Z",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1525.76,567.387C1525.76,567.387 1558.01,587.969 1591.04,567.387",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1557.76,453.032C1557.76,453.032 1560.22,531.987 1594.93,572.712C1602.75,581.89 1635.22,569.573 1626.82,560.915C1612.33,545.963 1580.85,482.896 1580.85,453.032",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.69551,0,0,1,474.525,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1572.97,279.045L1572.97,424.936L1540,424.936L1540,278.959L1572.97,279.045Z",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: "9.29px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1534.06,453.032C1534.06,453.032 1528.03,511.879 1490.14,560.295C1481.65,571.153 1515.62,588.111 1524.95,568.319C1533.12,551.003 1548.34,519.927 1553.84,486.62C1559.35,453.313 1557.43,453.032 1557.43,453.032",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519.93,453.032C1519.93,453.032 1499.45,506.274 1467.37,527.068C1455.83,534.547 1492.97,554.297 1493.4,554.759",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,3115.46,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519.93,453.032C1519.93,453.032 1499.45,506.274 1467.37,527.068C1455.83,534.547 1492.97,554.297 1493.4,554.759",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.591473,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519.93,453.032C1519.93,453.032 1506.78,470.671 1462.52,484.416C1445.24,489.781 1474.51,520.432 1474.74,520.206",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,3115.46,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519.93,453.032C1519.93,453.032 1506.78,470.671 1462.52,484.416C1445.24,489.781 1474.51,520.432 1474.74,520.206",
    style: {
      fill: "none",
      stroke: "rgb(159,175,202)",
      strokeWidth: 8
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Decorations",
    transform: "matrix(0.418878,0,0,0.418878,572.086,-30.5487)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.490196,0,0,0.490196,729.963,274.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.490196,0,0,0.490196,748.515,261.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.490196,0,0,0.490196,723.369,247.832)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.490196,0,0,0.490196,2235.54,274.335)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.490196,0,0,0.490196,2242.13,247.832)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.490196,0,0,0.490196,2217.81,261.02)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1381.53,
    cy: 512,
    r: 13.452,
    style: {
      fill: "none",
      stroke: "rgb(14,56,122)",
      strokeWidth: "9.65px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNwnBroom);
export default __webpack_public_path__ + "static/media/NWNBroom.6b242dce15248ffa423572014024f711.svg";
export { ForwardRef as ReactComponent };